<template src="./rateOverrideList.template.html"></template>
<script>
    import moment from "moment-timezone";
    export default {
        name: "rateOverrideList",
        data() {
            return {
                headerColumnList: {
                    PropertyName: { Label: "Property Name", IsChecked: true, ColumnName: "PropertyName" },
                    UnitName: { Label: "Unit Name", IsChecked: true, ColumnName: "UnitName" },
                    BaseRate: { Label: "Base Rate ", IsChecked: true, ColumnName: "BaseRate" },
                    RatePerAdditonalAdult: { Label: "Extra Person", IsChecked: true, ColumnName: "AdditionalAdultRate" },
                    RatePerAdditonalChild: { Label: "Extra Child", IsChecked: true, ColumnName: "AdditionalChildRate" },
                    DateEffective: { Label: "Date Effective", IsChecked: true, ColumnName: "DateEffective" },
                },
                rateOverrideList: [],
                loading:true
            };
        },
        methods: {
            createNewRateOverRide() {
                let vm = this;
                vm.$router.push("/rateOverride/" + "-1");
            },
            getRateOverrideList() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler",
                    {
                        key: "Get_RateOverride_List",
                        params: {
                            // ClientId,
                            PropertyId: -1,
                            UnitId: -1
                        },
                        callback: function (err, response) {
                            if (err) {
                                return;
                            }
                            if (response) {
                                
                                for(var i in response.recordsets){
                                    // response.recordsets[i].forEach(function (arrayItem) {
                                        //console.log("response.recordsets[i]", response.recordsets[i])
                                    
                                    // console.log("x", x)
                                    for(var j in response.recordsets[i]){
                                        //console.log("response.recordsets[i][j]", response.recordsets[i][j].DateEffective)
                                        var x = moment(response.recordsets[i][j].DateEffective).format("MMM DD YYYY");
                                        response.recordsets[i][j].DateEffective = x
                                        // console.log("response.recordsets[i][j]", response.recordsets[i][j])
                                    }
                                    // response.recordsets[i].DateEffective = x;
                                // });
                                }
                                
                                vm.rateOverrideList = response.recordsets[0];
                                //console.log("response in rateOverrideList", response.recordsets[0]);
                            }
                            vm.loading = false
                        }
                    });
            },
            viewRateOverrideDetailById(inst) {
                let vm = this;
                console.log("inst", inst)
                vm.$router.push("/rateOverride/" + inst.RateId);
            },
        },
        computed: {


        },
        watch: {

        },
        mounted() {
            console.log("ratesList mount");
            let vm = this;
            vm.getRateOverrideList();
        }
    };
</script>